// import React, { useState } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';

// const FlipkartReturnPage = () => {
//   const [selectedReason, setSelectedReason] = useState('');
//   const [comments, setComments] = useState('');
//   const [pickupMethod, setPickupMethod] = useState('schedule');
//   const [refundMethod, setRefundMethod] = useState('bank');

//   const handleSubmit = () => {
//     if (selectedReason) {
//       const returnId = 'RT' + Math.floor(Math.random() * 1000000000000);
//       alert(`Return request submitted successfully!\n\nReturn ID: ${returnId}\n\nYou will receive a confirmation email shortly.`);
//     }
//   };

//   const returnReasons = [
//     {
//       value: 'defective',
//       label: 'Product is defective/damaged',
//       desc: 'The product has physical damage or manufacturing defects'
//     },
//     {
//       value: 'wrong',
//       label: 'Wrong product delivered',
//       desc: 'Received a different product than what was ordered'
//     },
//     {
//       value: 'not-described',
//       label: 'Product not as described',
//       desc: 'Product doesn\'t match the description or images'
//     },
//     {
//       value: 'quality',
//       label: 'Quality is not as expected',
//       desc: 'Product quality is poor or below expectations'
//     },
//     {
//       value: 'dislike',
//       label: 'Did not like the product',
//       desc: 'Changed my mind or found a better alternative'
//     },
//     {
//       value: 'incomplete',
//       label: 'Product is incomplete',
//       desc: 'Missing parts, accessories, or components'
//     }
//   ];

//   return (
//     <div className="flipkart-return-page" style={{marginTop:"115px"}}>
//       {/* Header */}
//       <header className="flipkart-header">
//         <div className="container-fluid">
//           <div className="row align-items-center">
//             <div className="col-auto">
//               <div className="logo">
//                 Flipkart
//                 <div className="logo-subtitle">
//                   Explore <span className="text-warning">Plus</span>
//                 </div>
//               </div>
//             </div>
//             <div className="col-md-5">
//               <div className="search-container">
//                 <input
//                   type="text"
//                   className="form-control search-input"
//                   placeholder="Search for products, brands and more"
//                 />
//                 <span className="search-icon">🔍</span>
//               </div>
//             </div>
//             <div className="col-auto ms-auto">
//               <div className="d-flex gap-4 align-items-center">
//                 <button className="btn header-btn">Login</button>
//                 <button className="btn header-btn">Become a Seller</button>
//                 <button className="btn header-btn">More ▾</button>
//                 <button className="btn header-btn">🛒 Cart</button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </header>

//       {/* Breadcrumb */}
//       <div className="container">
//         <nav aria-label="breadcrumb" className="mt-3">
//           <ol className="breadcrumb custom-breadcrumb">
//             <li className="breadcrumb-item">
//               <a href="#">My Orders</a>
//             </li>
//             <li className="breadcrumb-item">
//               <a href="#">Order #OD424567890123456789</a>
//             </li>
//             <li className="breadcrumb-item active">Return</li>
//           </ol>
//         </nav>
//       </div>

//       {/* Main Content */}
//       <div className="container mt-3 mb-5">
//         <div className="row">
//           {/* Product Card */}
//           <div className="col-lg-4 mb-3">
//             <div className="card product-card">
//               <div className="card-body">
//                 <img
//                   src="https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400&h=400&fit=crop"
//                   alt="Product"
//                   className="img-fluid product-image mb-3"
//                 />
//                 <h6 className="product-title">
//                   Sony WH-1000XM4 Wireless Noise Cancelling Headphones
//                 </h6>
//                 <p className="product-details mb-1">Color: Black | Size: Standard</p>
//                 <h5 className="product-price">₹29,990</h5>
//                 <p className="product-seller">Seller: RetailNet</p>
//                 <hr />
//                 <p className="product-details mb-1">
//                   <strong>Order ID:</strong> OD424567890123456789
//                 </p>
//                 <p className="product-details mb-0">
//                   <strong>Delivered on:</strong> 28 Jan 2025
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* Return Form */}
//           <div className="col-lg-8">
//             <div className="card return-form-card">
//               <div className="card-body">
//                 {/* Info Banner */}
//                 <div className="alert alert-warning info-banner" role="alert">
//                   <strong>ⓘ</strong> You can return this product within 10 days of delivery. 
//                   Make sure the product is unused and in original packaging.
//                 </div>

//                 {/* Return Reason Section */}
//                 <div className="form-section">
//                   <h5 className="section-title">Why are you returning this?</h5>
//                   <p className="section-subtitle">Select the reason for return</p>

//                   {returnReasons.map((reason) => (
//                     <div
//                       key={reason.value}
//                       className={`reason-option ${selectedReason === reason.value ? 'selected' : ''}`}
//                       onClick={() => setSelectedReason(reason.value)}
//                     >
//                       <div className="form-check">
//                         <input
//                           className="form-check-input"
//                           type="radio"
//                           name="reason"
//                           id={reason.value}
//                           value={reason.value}
//                           checked={selectedReason === reason.value}
//                           onChange={(e) => setSelectedReason(e.target.value)}
//                         />
//                         <label className="form-check-label reason-label" htmlFor={reason.value}>
//                           {reason.label}
//                           <div className="reason-desc">{reason.desc}</div>
//                         </label>
//                       </div>
//                     </div>
//                   ))}

//                   <div className="mt-3">
//                     <textarea
//                       className="form-control"
//                       rows="4"
//                       placeholder="Please provide additional details (optional)"
//                       maxLength="500"
//                       value={comments}
//                       onChange={(e) => setComments(e.target.value)}
//                     />
//                     <div className="text-end text-muted small mt-1">
//                       {comments.length}/500
//                     </div>
//                   </div>
//                 </div>

//                 {/* Pickup Details Section */}
//                 <div className="form-section">
//                   <h5 className="section-title">Pickup Details</h5>
//                   <p className="section-subtitle">Choose how you'd like to return the product</p>

//                   <div
//                     className={`pickup-option ${pickupMethod === 'schedule' ? 'selected' : ''}`}
//                     onClick={() => setPickupMethod('schedule')}
//                   >
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="pickup"
//                         id="schedule"
//                         value="schedule"
//                         checked={pickupMethod === 'schedule'}
//                         onChange={(e) => setPickupMethod(e.target.value)}
//                       />
//                       <label className="form-check-label pickup-label" htmlFor="schedule">
//                         Schedule Pickup
//                       </label>
//                     </div>
//                     {pickupMethod === 'schedule' && (
//                       <div className="pickup-details mt-3">
//                         <div className="address-box">
//                           <strong>Rahul Sharma</strong><br />
//                           1234, MG Road, Koramangala,<br />
//                           Bangalore - 560034, Karnataka<br />
//                           Phone: +91 98765 43210
//                         </div>
//                         <div className="pickup-note mt-2">
//                           📦 Our delivery partner will pick up the product from this address within 2-3 business days
//                         </div>
//                       </div>
//                     )}
//                   </div>

//                   <div
//                     className={`pickup-option ${pickupMethod === 'dropoff' ? 'selected' : ''}`}
//                     onClick={() => setPickupMethod('dropoff')}
//                   >
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="pickup"
//                         id="dropoff"
//                         value="dropoff"
//                         checked={pickupMethod === 'dropoff'}
//                         onChange={(e) => setPickupMethod(e.target.value)}
//                       />
//                       <label className="form-check-label pickup-label" htmlFor="dropoff">
//                         Drop Off at Nearby Location
//                       </label>
//                     </div>
//                     {pickupMethod === 'dropoff' && (
//                       <div className="pickup-note mt-2">
//                         📍 Find and drop off at the nearest Flipkart authorized drop-off point
//                       </div>
//                     )}
//                   </div>
//                 </div>

//                 {/* Refund Details Section */}
//                 <div className="form-section">
//                   <h5 className="section-title">Refund Details</h5>
//                   <p className="section-subtitle">Choose how you'd like to receive your refund</p>

//                   <div
//                     className={`account-option ${refundMethod === 'bank' ? 'selected' : ''}`}
//                     onClick={() => setRefundMethod('bank')}
//                   >
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="refund"
//                         id="bank"
//                         value="bank"
//                         checked={refundMethod === 'bank'}
//                         onChange={(e) => setRefundMethod(e.target.value)}
//                       />
//                       <label className="form-check-label account-label" htmlFor="bank">
//                         Bank Account
//                         <div className="account-subtitle">
//                           Refund will be credited to your bank account in 5-7 business days
//                         </div>
//                       </label>
//                     </div>
//                   </div>

//                   <div
//                     className={`account-option ${refundMethod === 'wallet' ? 'selected' : ''}`}
//                     onClick={() => setRefundMethod('wallet')}
//                   >
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="refund"
//                         id="wallet"
//                         value="wallet"
//                         checked={refundMethod === 'wallet'}
//                         onChange={(e) => setRefundMethod(e.target.value)}
//                       />
//                       <label className="form-check-label account-label" htmlFor="wallet">
//                         Flipkart Wallet
//                         <div className="account-subtitle">
//                           Instant refund to your Flipkart wallet (can be used for future purchases)
//                         </div>
//                       </label>
//                     </div>
//                   </div>

//                   <div
//                     className={`account-option ${refundMethod === 'original' ? 'selected' : ''}`}
//                     onClick={() => setRefundMethod('original')}
//                   >
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="refund"
//                         id="original"
//                         value="original"
//                         checked={refundMethod === 'original'}
//                         onChange={(e) => setRefundMethod(e.target.value)}
//                       />
//                       <label className="form-check-label account-label" htmlFor="original">
//                         Original Payment Method
//                         <div className="account-subtitle">
//                           Refund to the payment method used during purchase (UPI/Card/Wallet)
//                         </div>
//                       </label>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Submit Button */}
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     disabled={!selectedReason}
//                     onClick={handleSubmit}
//                   >
//                     Submit Return Request
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FlipkartReturnPage;


import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const ReturnOrder = () => {
  const { orderId, productId } = useParams();
  const navigate = useNavigate();
  
  const [product, setProduct] = useState(null);
  const [orderInfo, setOrderInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  
  const [reason, setReason] = useState("");
  const [comment, setComment] = useState("");
  const [refundMode, setRefundMode] = useState("");
  const [bankDetails, setBankDetails] = useState({
    accountNumber: "",
    ifscCode: "",
    accountHolder: "",
  });
  const [upiId, setUpiId] = useState("");
  const [images, setImages] = useState([]);

  const user_id = localStorage.getItem("user_id");

  useEffect(() => {
    if (user_id && orderId && productId) {
      fetchOrderDetails();
    } else {
      setLoading(false);
    }
  }, [orderId, productId]);

  const fetchOrderDetails = async () => {
    try {
      const res = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_new_order",
        { user_id }
      );

      if (res.data.status === "true" || res.data.status === true) {
        const orders = res.data.data || [];
        const order = orders.find(o => o.order_id == orderId);
        
        if (order && order.items) {
          const productItem = order.items.find(item => item.product_id == productId);
          
          if (productItem) {
            setProduct(productItem);
            setOrderInfo(order);
          }
        }
      }
    } catch (error) {
      console.error("Order Fetch Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    setImages(files);
  };

  const handleSubmit = async () => {
    if (!reason || !comment) {
      alert("Please fill in all required fields");
      return;
    }

    if (!refundMode) {
      alert("Please select refund mode");
      return;
    }

    // Bank validation
    if (
      refundMode === "bank" &&
      (!bankDetails.accountHolder ||
        !bankDetails.accountNumber ||
        !bankDetails.ifscCode)
    ) {
      alert("Please fill all bank details");
      return;
    }

    setSubmitting(true);

    try {
      /* ===============================
         1️⃣ UPDATE ORDER STATUS → Return
         =============================== */
      await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_new_order",
        {
          order_id: orderId,
          order_status: "Return",
          payment_status: orderInfo.payment_status || "Paid",
        }
      );

      /* ======================================
         2️⃣ ADD RETURN REQUEST + REFUND
         ====================================== */
      const formData = new FormData();
      formData.append("order_id", orderId);
      formData.append("user_id", user_id);
      formData.append("seller_id", product.seller_id);
      formData.append("reason_for_return", reason);
      formData.append("comments", comment);
      formData.append("order_status", "Return");
      formData.append("payment_status", orderInfo.payment_status || "Paid");
      formData.append("payment_mode", orderInfo.payment_mode || "Online");

      if (refundMode === "wallet") {
        formData.append("upi_id", upiId || "");
      } else if (refundMode === "bank") {
        formData.append("account_holder_name", bankDetails.accountHolder);
        formData.append("account_number", bankDetails.accountNumber);
        formData.append("ifsc_code", bankDetails.ifscCode);
      }

      // Append images if any
      if (images.length > 0) {
        images.forEach((image) => {
          formData.append("multi_image[]", image);
        });
      }

      const res = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_order_return",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (!(res.data.status === true || res.data.status === "true")) {
        throw new Error("Return request failed");
      }

      /* ===============================
         3️⃣ SUCCESS
         =============================== */
      alert("Return request submitted successfully. Refund will be processed after product pickup.");
      
      navigate(`/my-orders`); // Or navigate to order details page

    } catch (error) {
      console.error("Return Order Error:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  if (!user_id) {
    return (
      <div className="container py-5 text-center">
        <h5>Please login to return order</h5>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="container py-5 text-center">
        <h5>Loading order details...</h5>
      </div>
    );
  }

  if (!product || !orderInfo) {
    return (
      <div className="container py-5 text-center">
        <h5>Order not found</h5>
      </div>
    );
  }

  return (
    <div className="cancel-page" style={{ marginTop: "115px" }}>
      <div className="cancel-wrapper">
        {/* LEFT SECTION */}
        <div className="cancel-left">
          {/* STEP 1 */}
          <div className="cancel-card">
            <div className="step-header active">
              <span className="step-number">1</span>
              <h4>EASY RETURN</h4>
            </div>

            <div className="form-body">
              <div className="form-row">
                <label>
                  Reason for Return <span>*</span>
                </label>

                <div className="select-box">
                  <select
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                  >
                    <option value="">Select Reason</option>
                    <option>Product is defective/damaged</option>
                    <option>Wrong product delivered</option>
                    <option>Product not as described</option>
                    <option>Quality is not as expected</option>
                    <option>Did not like the product</option>
                    <option>Product is incomplete</option>
                  </select>
                </div>
              </div>

              <div className="form-row">
                <label>
                  Comments <span>*</span>
                </label>
                <textarea
                  placeholder="eg: Product received is damaged"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                />
              </div>

              <div className="form-actions">
                <button
                  className="continue-btn"
                  onClick={() => {
                    if (!reason || !comment) {
                      alert("Please fill in reason and comments");
                    }
                  }}
                >
                  CONTINUE
                </button>
              </div>
            </div>
          </div>

          {/* STEP 2 - REFUND MODES */}
          <div className="cancel-card">
            <div className="step-header active">
              <span className="step-number">2</span>
              <h4>REFUND MODES</h4>
            </div>

            <div className="form-body">
              <p className="refund-info">
                Choose how you'd like to receive your refund
              </p>

              <div className="refund-options-horizontal">
                <label className="refund-option-card">
                  <input
                    type="radio"
                    name="refundMode"
                    value="wallet"
                    checked={refundMode === "wallet"}
                    onChange={(e) => setRefundMode(e.target.value)}
                  />
                  <div className="refund-content">
                    <strong>Refund to UPI</strong>
                    <small>Instant refund to your UPI ID</small>
                  </div>
                </label>

                <label className="refund-option-card">
                  <input
                    type="radio"
                    name="refundMode"
                    value="bank"
                    checked={refundMode === "bank"}
                    onChange={(e) => setRefundMode(e.target.value)}
                  />
                  <div className="refund-content">
                    <strong>Bank Transfer</strong>
                    <small>Direct transfer to your bank account (3-5 days)</small>
                  </div>
                </label>
              </div>

              {/* Conditional Bank Details Form */}
              {refundMode === "bank" && (
                <div className="bank-details-form">
                  <h5>Enter Bank Details</h5>
                  
                  <div className="form-row">
                    <label>
                      Account Holder Name <span>*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter account holder name"
                      value={bankDetails.accountHolder}
                      onChange={(e) =>
                        setBankDetails({
                          ...bankDetails,
                          accountHolder: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div className="form-row">
                    <label>
                      Account Number <span>*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter account number"
                      value={bankDetails.accountNumber}
                      onChange={(e) =>
                        setBankDetails({
                          ...bankDetails,
                          accountNumber: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div className="form-row">
                    <label>
                      IFSC Code <span>*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter IFSC code"
                      value={bankDetails.ifscCode}
                      onChange={(e) =>
                        setBankDetails({
                          ...bankDetails,
                          ifscCode: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              )}

              {/* Conditional UPI Form */}
              {refundMode === "wallet" && (
                <div className="bank-details-form">
                  <div className="form-row">
                    <label>UPI ID (Optional)</label>
                    <input
                      type="text"
                      placeholder="Enter UPI ID (e.g., name@upi)"
                      value={upiId}
                      onChange={(e) => setUpiId(e.target.value)}
                    />
                  </div>
                  <p className="wallet-note">
                    Refund will be instantly credited to your Garshya wallet balance.
                  </p>
                </div>
              )}

              <div className="form-body">
                <div className="col-lg-6">
                  <label className="">Upload Product Images</label>
                  <input 
                    type="file" 
                    multiple 
                    className="form-control"
                    accept="image/*"
                    onChange={handleImageUpload}
                  /> 
                  {images.length > 0 && (
                    <small className="text-muted mt-2 d-block">
                      {images.length} file(s) selected
                    </small>
                  )}
                </div>
              </div>

              <div className="form-actions">
                <button
                  className="submit-btn"
                  disabled={!refundMode || submitting}
                  onClick={handleSubmit}
                  style={{
                    backgroundColor: "#ff6634",
                    color: "white",
                    padding: "12px 30px",
                    border: "none",
                    cursor: refundMode && !submitting ? "pointer" : "not-allowed",
                    opacity: refundMode && !submitting ? 1 : 0.6,
                  }}
                >
                  {submitting ? "SUBMITTING..." : "SUBMIT RETURN REQUEST"}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT SECTION */}
        <div className="cancel-right">
          <div className="item-card">
            <h5>ITEM DETAILS</h5>

            <div className="item-info">
              <div>
                <p className="item-title">
                  {product.product_name}
                </p>
                <p className="qty">Qty: {product.qty}</p>
                <h4>₹{product.subtotal || (product.price * product.qty)}</h4>
              </div>
               
              <div className="Product-image"> 
                <img
                  src={
                    product.multi_image
                      ? `https://cyberathon.com/multivendor/${product.multi_image}`
                      : "https://via.placeholder.com/150"
                  }
                  alt={product.product_name}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnOrder;